import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { BlackMask } from "../../../../../../components/mask";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useSelector } from "react-redux";
import AutoWidthSwiper from "../../../../../../components/swiper/autowidth";
import { useState } from "react";
import { useEffect } from "react";
import ReactDOM from 'react-dom';
import BottomToTop from "../../../../../../components/transitions/bottom-to-top";
import { FormattedMessage, useIntl } from "react-intl";
import { useCallback } from "react";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import Deeplink from "../../../../../../../utils/deeplink";
import { isIOS, isMacOs } from "react-device-detect";
import { fetchRedeemFreeShipping } from "../../../../../../../api";
import Alert from "../../../../../../components/alert/index";
import NormalConfigConfirm from "../../../../../../../client/components/alert/config-confirm";


const VipRewardsMessage = props =>{
    const { currentIndex, rewards } = props;
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const history = useHistory();
    const global = useSelector(state=>state.global);
    const { config } = global;
    const Intl = useIntl();

    const selectedModalReawrds = useMemo(() =>{
        if(rewards){
            return rewards[currentIndex]
        }
    }, [rewards, currentIndex])

    const modalRewardsEvent = useCallback(() =>{
        let type = selectedModalReawrds?.deepLink?.type;
        switch(type){
            case 33:
                // 积分兑换优惠券
                history.push("/user/redeem-coupon");
                break;
            case 34:
                // App专属价格 跳转app
                handleClick();
                break;
            case 3:
                // 查看升级优惠券
                history.push("/user/coupons");
                break;
            case 25:
                // constant us
                window.location.href = "/user/support/ticketvip";
                break;
            default:
                window.location.href = Deeplink(selectedModalReawrds?.deepLink, "msite");
                break;
        }

        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks: selectedModalReawrds.refId,
                page_sort:"VIP",
                page_content:"Rewards",
                get_rewards:true
            })
        }
    }, [selectedModalReawrds])

    const handleClick = useCallback(() => {
        if (isIOS || isMacOs) {
            setTimeout(() => {
                window.location.href = `https://itunes.apple.com/us/app/chic-me-shopping-sharing-saving/id${config?.app.ios.id}?l=zh&ls=1&mt=8`;
            }, 200);
            window.location.href = `chic-me://chic.me/`;
        } else {
            setTimeout(() => {
                window.location.href = `https://play.google.com/store/apps/details?id=${config?.app.android.id}`;
            }, 200);
            window.location.href = `chic-me://chic.me/`;
        }
    }, []);

    const getRewardEvent = useCallback(async () =>{
        try {
            let path = selectedModalReawrds?.deepLink?.params?.[0];
            if(path){
                setButtonDisabled(true);
                let response = await fetchRedeemFreeShipping(path);
                if(response?.code === 200){
                    NormalConfigConfirm({
                        message:{
                            text:`<span class="iconfont" style="color:#ff8031;font-size:60px;">&#xe6b7;</span><br/><p style="font-size:16px;font-family: 'Roboto-Bold';">${Intl.formatMessage({ id: "points_redeem_success", defaultMessage: "Redemption successful!" })}</p><br/>`,
                            style:{
                                lineHeight:"normal"
                            },
                            html:true
                        },
                        btn1:{
                            text:Intl.formatMessage({ id: "go_shopping", defaultMessage: "Go Shopping" }),
                            clickHandle:() =>{
                                window.location.href = "/";
                            }
                        },
                        btn2:{},
                        close:{}
                    });

                    if(window.GeekoSensors){
                        window.GeekoSensors.Track('ELClick', {
                            clicks: selectedModalReawrds.refId,
                            page_sort:"VIP",
                            page_content:"Rewards",
                            get_rewards:true
                        })
                    }
                }else{
                    setButtonDisabled(false);
                    response?.result && Alert(response.result);
                }
            }
        } catch (error) {
            console.log('error', error)
        }
    }, [selectedModalReawrds])

    return <div className={cls.VipRewardsMessage}>
        <div className={cls.NextTitle}>{selectedModalReawrds.title}</div>
        <div className={cls.MessageContent}>{selectedModalReawrds.description}</div>

        <div className={cls.RewardsButton}>
            {
                selectedModalReawrds.buttonText && selectedModalReawrds.id != 5 && <React.Fragment>
                    <button 
                        onClick={modalRewardsEvent}
                        disabled={selectedModalReawrds.buttonDisabled}
                    >{selectedModalReawrds.buttonText}</button>
                </React.Fragment>
            }

            {
                selectedModalReawrds.id == 5 && selectedModalReawrds.buttonText && <React.Fragment>
                    <button 
                        disabled={selectedModalReawrds.buttonDisabled || buttonDisabled}
                        onClick={getRewardEvent}
                    >{selectedModalReawrds.buttonText}</button>
                </React.Fragment>
            }
        </div>
    </div>
}

const RewardsModalItem = props =>{
    const { reward, userLevel, upgradeFlag, themeColor } = props;

    const handleClick = useCallback(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks: reward.refId,
                page_sort:"VIP",
                page_content:"Rewards"
            })
        }
    }, [])

    return <div className={cls.RewardsModal} style={{backgroundImage: `url(${reward?.icon})`}} onClick={() =>handleClick(reward)}>
        {
            (userLevel < reward.level) && <span className={cls.RewardLock}>
                <span className={cls.RewardLockItem} style={{backgroundColor:`${themeColor[reward.level]}`}}>
                    <Iconfont className={cls.Icon}>&#xe70c;</Iconfont>
                    <span className={cls.Level}>v{reward.level}</span>
                </span>
            </span> 
        }
        {
            (userLevel == reward.level && upgradeFlag) && <span className={cls.RewardLock}>
                <span className={`${cls.RewardLockItem} ${cls.NewLevel}`} style={{backgroundColor:`${themeColor[reward.level]}`}}>
                    <span className={cls.Level}><FormattedMessage id="new_in" defaultMessage="New" /></span>
                </span>
            </span>
        }
    </div>
}

const VipRewardsSwiper = props =>{
    const { modalIndex, rewards, setCurrentIndex, setSensorIndex } = props;
    const [swiper, setSwiper] = useState(null);

    useEffect(() =>{
        swiper?.slideTo(modalIndex);
    }, [modalIndex]);

    const changeHandle = (swiper) =>{
        setCurrentIndex(swiper?.activeIndex);
        setSensorIndex(swiper?.activeIndex);
    }

    return <div className={cls.VipRewardsSwiper}>
        <AutoWidthSwiper
            items={rewards}
            options={{
                slidesPerView:'auto',
                slideToClickedSlide: true,
                centeredSlides: true,
                spaceBetween : 14,
                initialSlide: modalIndex,
                onInit:setSwiper,
                onSlideChange:changeHandle
            }}
            className={cls.VipRewardsSwiperCon}
            render={(item, index) =>{
                return <React.Fragment>
                    <RewardsModalItem 
                        key={item?.id+index} 
                        reward={item} 
                        {...props}
                    />
                </React.Fragment>
            }}
        />
    </div>
}

const VipRewardsModal = (props) =>{
    useStyles(cls);
    const { onClose, modalIndex, rewards, setSensorIndex } = props;
    const global = useSelector(state=>state.global);
    const { config } = global;
    const [currentIndex, setCurrentIndex] = useState(modalIndex);

    return <div className={cls.VipRewards}>
        <div className={cls.CloseIcon}>
            <Iconfont onClick={onClose}>&#xe69a;</Iconfont>
        </div>

        <p className={cls.Title}><FormattedMessage id="vip_rewards" defaultMessage="{name} Vip Rewards" values={{name:config?.name}} /></p>

        <VipRewardsSwiper 
            {...props} 
            setCurrentIndex={setCurrentIndex} 
            setSensorIndex={setSensorIndex}
        />

        <VipRewardsMessage rewards={rewards} currentIndex={currentIndex} />
    </div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show, onClose } = props;

	return <React.Fragment>
		<BottomToTop in={show} className={cls.VipRewardsModal}>
			<div>
                <VipRewardsModal {...props} />
			</div>
		</BottomToTop>

        {
            show && <BlackMask onClick={onClose} />
        }
	</React.Fragment>
}

export default props =>{
    if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}